import React from 'react'

const Footer = () => {
  return (
    <div className='flex bg-black text-gray-400 pb-10 justify-center'>
        All rights reserved © Rijan Shrestha
    </div>
  )
}

export default Footer